module.exports = __webpack_public_path__ + "static/media/giftPhoneImg.8fb2ce61.png";